import React from 'react';
import { Helmet } from 'react-helmet';
import { FaPaintRoller } from 'react-icons/fa';

const ConstructionCalculators = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-yellow-100 to-orange-100">
      <Helmet>
        <title>Construction Calculators | Comprehensive Construction Tools</title>
        <meta name="description" content="Collection of 175+ construction calculators for contractors, architects, and DIY enthusiasts. Calculate materials, structural requirements, and more for your construction projects." />
        <meta name="keywords" content="construction calculators, concrete calculator, brick calculator, paint calculator, beam load calculator, foundation calculator, roof pitch calculator" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="header-icon text-4xl text-yellow-600 mb-4">🏗️</div>
          <h1 className="text-4xl font-bold text-gray-800 mb-2">Construction Calculators</h1>
          <p className="calculator-count text-xl text-gray-600">175+ calculators</p>
        </div>

        <div className="max-w-2xl mx-auto mb-12">
          <div className="calculator-description bg-white p-6 rounded-lg shadow-md">
            <p className="text-gray-600 mb-4">
              Access our comprehensive suite of construction calculators designed for contractors, architects, and DIY enthusiasts. From material estimations to structural calculations, our tools help you plan and execute construction projects with precision and confidence.
            </p>
            <button className="read-more inline-block bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-yellow-600 transition-colors">
              Read more
            </button>
          </div>
        </div>

        <div className="calculator-section mb-12">
          <h2 className="section-title text-2xl font-bold text-gray-800 mb-6 flex items-center">
            Material calculators <span className="emoji ml-2">🧱</span>
          </h2>
          <div className="calculator-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/concrete-volume" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Concrete Volume Calculator</h3>
                <p className="text-gray-600">Calculate concrete volume needed for your project</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/brick-calculator" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Brick Calculator</h3>
                <p className="text-gray-600">Estimate the number of bricks needed for walls</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/construction/paint-coverage" className="calculator-link block">
                <h3 className="flex items-center">
                  <FaPaintRoller className="mr-2" /> Paint Coverage Calculator
                </h3>
                <p className="text-gray-600">Calculate paint requirements for walls including windows/doors</p>
              </a>
            </div>
          </div>
        </div>

        <div className="calculator-section">
          <h2 className="section-title text-2xl font-bold text-gray-800 mb-6 flex items-center">
            Structural calculators <span className="emoji ml-2">🏛️</span>
          </h2>
          <div className="calculator-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/beam-load" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Beam Load Calculator</h3>
                <p className="text-gray-600">Calculate beam loading and deflection</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/foundation-size" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Foundation Size Calculator</h3>
                <p className="text-gray-600">Determine required foundation dimensions</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/roof-pitch" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Roof Pitch Calculator</h3>
                <p className="text-gray-600">Calculate roof slope and dimensions</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstructionCalculators;